
export class GUIComponentField {
    id: number;
    name: string;
    attributeName: string;
    ddKey: string;
    objectUID?: string;
}

export class GUIComponent extends GUIComponentField {
    children: GUIComponent[];
    controlType: string;
    fields: GUIComponent[];
    label: string;
    name: string;
    position: number;
    sortorder: number;
    rightLevel: number;
    visibleAttributes: boolean;
}

export class DynamicComponent {
    conditions: Condition;
    guiComponent: GUIComponent;
    dynamicObjects: DynamicObjects[];
}

export class DynamicValue {
    attributeName: string;
    attributeType: string;
    source: string;
    value: string;
    oldValue: string;
    useOldValue: boolean;
}

export class DynamicObjects {
    children: DynamicObjects[];
    dynamicClassName: string;
    objGuid: string;
    values: DynamicValue[];
}

export declare class Condition {
    contexts: string[];
    triggers: string[];
}

export class DynamicContent {
    _dynamicComponent: DynamicComponent;
}
